<template>
  <div id="app">
    <v-app>
      <component :is="layout">
        <router-view/>
      </component>
    </v-app>
  </div>
</template>

<script>
const default_layout = "application";
import { mapActions } from 'vuex'

export default {
  computed: {
    layout(){
      return "layout-" + (this.$route.meta.layout || default_layout);
    },
    dark_theme: {
      get() {
        return this.$store.state.theme.dark_theme
      },
      set() {
        this.setTheme()
      }
    }
  },
  mounted(){
    this.$vuetify.theme.dark=this.dark_theme
  },
  watch:{
    dark_theme(val){
      this.$vuetify.theme.dark=val
    }
  },
  methods:mapActions({
    setTheme: 'theme/setTheme'
  })

}
</script>
